import graphql__d5b3f40b5052fb36f025 from "./__generated__/Page_page.graphql.js";import { graphql, useFragment } from "react-relay";

import PageSections from "../PageSection/PageSections";
import PageTitle from "./PageTitle";
import PushableContainer from "../Utils/PushableContainer";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";

const Page = props => {
  const page = useFragment(Page_page, props.page);
  const { isNonDesktop } = useResponsiveFlag();

  return (
    <PushableContainer preventPush={isNonDesktop}>
      <div className="padding-y-xs container">
        <PageTitle page={page} title={page.title} />
      </div>

      <PageSections page={page} />
    </PushableContainer>
  );
};

const Page_page = graphql__d5b3f40b5052fb36f025;

export default Page;
